

export class TimeZoneStatusInput implements ITimeZoneStatusInput {
    /** The auto-generated id of the time zone master */
    timeZoneId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITimeZoneStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TimeZoneStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITimeZoneStatusInput {
    /** The auto-generated id of the time zone master */
    timeZoneId: number;
    /** The updated status */
    status: number;
}

